var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flw100",staticStyle:{"position":"relative","padding-top":"100px"}},[_c('div',{staticStyle:{"position":"absolute","left":"50%"}},[_c('vap-spinner',{attrs:{"medium":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }